import { render, staticRenderFns } from "./TraditionalMedicine.vue?vue&type=template&id=5cf2783c&"
import script from "./TraditionalMedicine.vue?vue&type=script&lang=js&"
export * from "./TraditionalMedicine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports